import React from 'react'

import PropTypes from 'prop-types'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

import TableHeaders from './TableHeaders'

const DEFAULT_TABLE = {
  disabledSelect: false,
}

function SharedTable({
  table = DEFAULT_TABLE,
  onCheckboxClick = NOOP,
  selectedRows = EMPTY_ARRAY,
  disabledRows = EMPTY_ARRAY,
  onRowClick = NOOP,
  renderPlaceholder = null,
}) {
  function handleSelect(id) {
    if (!table.disabledSelect) {
      onCheckboxClick(id)
    }
  }

  if (!table.rows.length && !!renderPlaceholder) {
    return renderPlaceholder()
  }

  return (
    <table width="100%" className={table.className} style={table.tableStyle}>
      {table.colgroup.length > 0
        && (
        <colgroup>
          {table.colgroup.map((col, id) => <col key={id+col} style={{ width: col }} />)}
        </colgroup>
        )
      }
      {table.headers
        && <TableHeaders headers={table.headers} select={false} />
      }
      <tbody>
        {table.rows.map((model, index) => {
          const id = model.id
          const isChecked = !!selectedRows.find(item => item.id === id)
          const isDisabled = !!disabledRows.find(item => item.id === id)
          const isCheckedClass = isChecked ? 'is-selected' : ''
          const isDisabledClass = isDisabled ? 'is-disabled' : ''
          const isExpandedClass = model.child && model.childExpanded ? 'is-expanded' : ''

          return (
            <React.Fragment key={index}>
              <tr key={id} className={`${isCheckedClass} ${isExpandedClass} ${isDisabledClass}`}>
                {table.select
                  && (
                  <td className="selector u-text-center" onClick={() => handleSelect(id)}>
                    <input
                      type="checkbox"
                      id={`select-model-${id}`}
                      className="checkbox"
                      checked={isChecked}
                      onChange={() => onCheckboxClick(id)}
                      disabled={isDisabled || table.disabledSelect}
                    />
                    <label htmlFor={`select-model-${id}`} />
                  </td>
                  )
                }
                {
                  model.columns.map((column, index) => {
                    return <td key={id + index} className={column.customClass} onClick={() => onRowClick(id)}>{column.content}</td>
                  })
                }
              </tr>
              {model.child && model.childExpanded
                && <tr key={`child-${id}`} colSpan={model.columns.length + 1}>{model.child}</tr>
              }
            </React.Fragment>
          )
        })}
      </tbody>
    </table>
  )
}

SharedTable.propTypes = {
  renderPlaceholder: PropTypes.func,
  table: PropTypes.shape({
    headers: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]).isRequired,
    rows: PropTypes.array.isRequired,
    colgroup: PropTypes.array.isRequired,
    disabledSelect: PropTypes.bool,
  }).isRequired,
  onCheckboxClick: PropTypes.func,
  selectedRows: PropTypes.array,
  disabledRows: PropTypes.array,
  onRowClick: PropTypes.func,
}

export default SharedTable
